import React from 'react'
import CustomDataGrid from '../components/CustomDataGrid'
import { Box } from '@mui/material'

const WholesalerFormListPage: React.FC = () => {
  return (
    <Box display='flex'>
      <Box width='100%' position='relative'>
        <CustomDataGrid />
      </Box>
    </Box>
  )
}

export default WholesalerFormListPage
